// Attribute keys the vehicle form's free-form attribute editor never shows. Each is owned by
// its own section (marker picker, Sensors, Fuel calibration, Engine signals), so the main Save
// must carry them through untouched instead of treating "absent from the editor" as "deleted".
export const SECTION_OWNED_KEYS = ['mapMarker', 'mapIcon', 'mapMarkerStyle', 'mapMarkerIcon', 'sensorConfig', 'fuelCalibration', 'canSignals', 'mapLabelStyle'];

export function editableAttributes(deviceAttrs) {
  const attrs = { ...(deviceAttrs || {}) };
  for (const k of SECTION_OWNED_KEYS) delete attrs[k];
  return attrs;
}

// The attributes to save: the device's current attributes, with the editor's values applied and
// editor-visible keys the user removed deleted. Section-owned keys survive as they are.
export function buildSavedAttributes(deviceAttrs, editableAttrs) {
  const attrs = { ...(deviceAttrs || {}) };
  Object.entries(editableAttrs || {}).forEach(([k, v]) => { attrs[k] = v; });
  Object.keys(editableAttributes(deviceAttrs)).forEach((k) => {
    if (!(k in (editableAttrs || {}))) delete attrs[k];
  });
  return attrs;
}
